import React from 'react'
import LoginComponent from '../Components/Login/LoginComponent'

function LoginPage() {
    return (

        <LoginComponent/>
    )
}

export default LoginPage